const dataEngineerQ = {
    topic: 'Data Engineer',
    questions: [
        {
            questionId: 1,
            question: 'What is ETL, and why is it important in Data Engineering?',
            correctAnswer: `ETL stands for Extract, Transform, Load. It is the process of extracting data from different sources, transforming it into a proper format or structure for analysis, and then loading it into a database or data warehouse. ETL is important because it ensures that data is clean, structured, and ready for analysis, allowing organizations to make data-driven decisions.`
        },
        {
            questionId: 2,
            question: 'When would you choose to use **Parquet** format over **CSV** in a data pipeline, and why?',
            correctAnswer: `Parquet is a columnar storage format that is optimized for large-scale data analytics. You would choose Parquet over CSV when working with big data, particularly for read-heavy tasks or when performing queries on specific columns, as it allows faster reads, better compression, and efficient storage of large datasets. CSV, on the other hand, is a simple text format, which may not be efficient for larger data volumes.`
        },
        {
            questionId: 3,
            question: 'What is the role of **data partitioning** in a distributed system like Hadoop or Spark?',
            correctAnswer: `Data partitioning involves dividing a large dataset into smaller, more manageable pieces(partitions) that can be processed in parallel across multiple machines in a distributed system like Hadoop or Spark. Partitioning improves performance by allowing parallelism and reducing the amount of data processed by each worker node. It also optimizes data locality, as each node works on the data stored closest to it. Efficient partitioning is key to scaling data pipelines in distributed environments.`
        },
        {
            questionId: 4,
            question: `You are given a CSV file containing customer orders:
                    OrderID, CustomerID, OrderAmount, OrderDate
                    1001, 200, 250.75, 2023-09-10
                    1002, 201, 125.00, 2023-09-12
                    1003, 202, 500.00, 2023-09-14
                    1004, 200, 300.00, 2023-09-15
                    1005, 202, 450.50, 2023-09-16
                    Write a Python script that:
                    1. Loads the CSV into a Pandas DataFrame.
                    2. Aggregates the total 'OrderAmount' for each 'CustomerID'.
                    3. Filters and displays only those customers whose total order amount exceeds 400.`,
            correctAnswer: `import pandas as pd
                            # Load the CSV file into a DataFrame
                            df = pd.read_csv(&#39;orders.csv&#39;)

                            # Group by CustomerID and calculate total OrderAmount
                            total_orders = df.groupby(&#39;CustomerID&#39;)[&#39;OrderAmount&#39;].sum().reset_index()

                            # Filter customers with total order amount greater than 400
                            high_value_customers = total_orders[total_orders[&#39;OrderAmount&#39;] &gt; 400]

                            print(high_value_customers)`
        },
        {
            questionId: 5,
            question: `You are working with a large log file that cannot fit into memory. Each line in the file is a JSON object representing an event, and your task is to count how many times each event type occurs. Write a Python script that:
                        1. Reads the log file line by line.
                        2. Counts the occurrences of each event type (assume event type is stored as 'event_type' in the JSON).
                        3. Displays the event type counts.`,
            correctAnswer: `import json
                            # Initialize a dictionary to store event type counts
                            event_counts = {}
                            # Open and process the log file line by line with open(&#39;large_log_file.txt&#39;, &#39;r&#39;) as f: for line in f:
                            # Parse each line as JSON
                            event = json.loads(line)
                            event_type = event.get(&#39;event_type&#39;)
                            # Count occurrences of each event type
                            if event_type in event_counts:
                                event_counts[event_type] += 1
                            else:
                                event_counts[event_type] = 1

                            # Display the event type counts
                            for event_type, count in event_counts.items():
                                print(f&quot;{event_type}: {count}&quot;)`
        },
        {
            questionId: 6,
            question: `You are given a CSV file 'sales.csv' with sales data:
                        SaleID, ProductID, SaleAmount, SaleDate
                        1001, 2001, 500.75, 2023-09-10
                        1002, 2002, 120.00, 2023-09-12
                        1003, 2003, 230.50, 2023-09-13

                        Write a Python script that:
                        1. Loads the CSV file into a Pandas DataFrame.
                        2. Creates a new column called 'SaleCategory' which assigns '&quot;High&quot;' if 'SaleAmount' &gt; 200, else '&quot;Low&quot;'.
                        3. Saves the transformed DataFrame to a new CSV file.`,
            correctAnswer: `import pandas as pd
                            # Load the sales data into a DataFrame
                            df = pd.read_csv(&#39;sales.csv&#39;)

                            # Add a new column &#39;SaleCategory&#39; based on SaleAmount
                            df[&#39;SaleCategory&#39;] = df[&#39;SaleAmount&#39;].apply(lambda x: &#39;High&#39; if x &gt; 200 else &#39;Low&#39;)

                            # Save the transformed data to a new CSV file
                            df.to_csv(&#39;transformed_sales.csv&#39;, index=False)

                            print(&quot;Transformed data saved to transformed_sales.csv&quot;)`
        }
    ]
}

export default dataEngineerQ;
